import { attachAuthInterceptors } from '@repo/auth/axios';
import axios from 'axios';

import { authClient } from 'src/app/auth/auth-client';
import { getLocale } from 'src/packages/language/utils';

import { API_GOSTORAGE_URL } from './consts';

const goStorageAgent = axios.create({
  baseURL: API_GOSTORAGE_URL,
  headers: {
    'content-type': 'application/json',
  },
});

attachAuthInterceptors(goStorageAgent, authClient);

goStorageAgent.interceptors.request.use((config) => {
  config.headers['accept-language'] ??= getLocale();
  return config;
});

export { goStorageAgent };
